"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var link_1 = __importDefault(require("next/link"));
var Navigation = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Product' : _b;
    return ((0, jsx_runtime_1.jsx)("nav", { className: "w-full flex items-center justify-between print:hidden", children: (0, jsx_runtime_1.jsx)(link_1.default, { href: "/", "data-test-id": "navigation-title", className: "dark:hover:text-rose-300 hover:text-rose-500 text-lg font-bold tracking-tight leading-tight", children: title }) }));
};
exports.default = Navigation;
